import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/avisoAssunto/';

class AvisoAssuntoService{
  constructor() {
    LoginService.currentUser.subscribe(data => {
      this.headers = {
        'Content-Type':'application/json',
        'authorization':'Bearer ' + (data ? data.token:'')
      };
    });
  }

  findAssuntoById(id){
    return axios.get(API_URL+ 'id?id='+id,{headers: this.headers});
  }

  findAssuntoByFiltro(idCliente, filtro){
    return axios.get(API_URL+ 'allAssunto?idCliente='+idCliente+'&filtro='+filtro, {headers: this.headers});
  }

  findAssunto(idCliente, filtro){
    return axios.get(API_URL+ 'allAssunto?idCliente='+idCliente+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data));
  }

  saveAssunto(assunto){
    return axios.post(API_URL, JSON.stringify(assunto), {headers: this.headers});
  }

  removeAssunto(id){
    return axios.delete(API_URL, id, {headers: this.headers});
  }
}

export default new AvisoAssuntoService();